import React, {useState, useEffect} from 'react';

function ChartSettingsComponent(props) {

    function onHeightChange(event) {
        let value = event.target.value.replace(/\D/g, "");
        if (value) {
            value = parseInt(value);
        } else {
            value = 0;
        }
        props.setChartConfigurations({
            ...props.chartConfigurations,
            height: value
        });
    }

    function onKeyDownEvent(event) {
        if(event.key === "Enter") {
            props.refreshChart();
        }
    }

    function onWidthChange(event) {
        let value = event.target.value.replace(/\D/g, "");
        if (value) {
            value = parseInt(value);
        } else {
            value = 0;
        }
        props.setChartConfigurations({
            ...props.chartConfigurations,
            width: value
        });
    }


    function onScaleChange(event) {
        let value = event.target.value.replace(/\D/g, "");
        if (value) {
            value = parseInt(value);
        } else {
            value = 0;
        }
        props.setChartConfigurations({
            ...props.chartConfigurations,
            scale: value
        });
    }

    function onMarginChange(event) {
        let value = event.target.value.replace(/\D/g, "");
        if (value) {
            value = parseInt(value);
        } else {
            value = 0;
        }
        props.setChartConfigurations({
            ...props.chartConfigurations,
            marginLeft: value
        });
    }

    return (
        <React.Fragment>
            <span className="questionaire__reports__container__title__actions__inputs questionaire__reports__container__title__actions--active">
                <span>
                    <label htmlFor="hight_1">Height (px)</label>
                    <input value={props.chartConfigurations.height} onChange={onHeightChange} type="text"
                           id="hight_1" onKeyDown={onKeyDownEvent} onBlur={props.refreshChart}/>
                </span>
                {
                    !props.isMobile &&
                    <span>
                        <label htmlFor="width_1">Width (px)</label>
                        <input value={props.chartConfigurations.width} onChange={onWidthChange} type="text"
                               id="width_1" onKeyDown={onKeyDownEvent} onBlur={props.refreshChart}/>
                    </span>
                }
                {
                    (props.viewType !== 'Stacked') &&
                    <span>
                        <label htmlFor="scale_1">X axis (%)</label>
                        <input value={props.chartConfigurations.scale} onChange={onScaleChange} type="text"
                               id="scale_1" onKeyDown={onKeyDownEvent} onBlur={props.refreshChart}/>
                    </span>
                }
                {
                    !props.isMobile &&
                    <span>
                        <label htmlFor="margin_1">Labels space (px)</label>
                        <input value={props.chartConfigurations.marginLeft} onChange={onMarginChange} type="text"
                               id="margin_1" onKeyDown={onKeyDownEvent} onBlur={props.refreshChart}/>
                    </span>
                }
            </span>
        </React.Fragment>)
}

export default ChartSettingsComponent;